<template>
    <div class="bigBox">
        <!--        左边印章区-->
        <div class="leftBox">
            <div
                    class="oneDiv"
                    draggable="true"
                    @dragstart="dragstart($event, item)"
                    @dragend="dragend"
                    v-for="(item, index) in dragList"
                    :key="index"
            >
                <img :src="item.img" alt="" style="width: 150px;height: 150px">
            </div>
        </div>
        <!--     中间文档区   -->
        <div class="middleBox" id="middleBox">
            <div class="pdfBox">
                <div class="pdfLeftBox">
                    <!-- 给拖拽存放区添加拖拽存放区事件 -->
                    <div class="drag" @drop="drop" @dragover.prevent>
                        <div id="exportPdf" ref="exportPdf">
                            <pdf
                                    ref="myPdfComponent"
                                    :src="url"
                                    @num-pages="pageCountChange"
                                    @page-loaded="currentPageChange"
                                    :page="currentPage"
                                    class="pdf-content"
                            />
                            <div
                                    v-for="(item, index) in dropData"
                                    :key="index">
                                <div
                                        :class="['box', item.selectName]"
                                        @mousedown="move($event, item)"
                                        @click="getModel(item)"
                                        :style="{ left: item.left + 'px', top: item.top + 'px', backgroundImage: 'url(' + item.img + ')'}"
                                        style="background-size: 100% 100%"
                                >
<!--                                    {{positionX}}-&#45;&#45;{{positionY}}-->
<!--                                    <img :src="item.img" alt="" style="width: 100px;height: 100px">-->
                                    <div style="margin-top: 160px;text-align: center"><span @click="deleteBtn(item,index)">删除</span></div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="pdfRightBox">
                    <div class="pdf-box">
                        <div>
                            <el-button type="primary" @click="backPage">上一页</el-button>
                        </div>
                        <div class="pageNumber">{{currentPage}} / {{pageCount}}</div>
                        <div>
                            <el-button type="primary" @click="addPage">下一页</el-button>
                        </div>
                    </div>
                    <div style="display: flex;margin: 10px 0px">
                        <el-button type="primary" style="margin:0px 10px;" @click="deleteBtn">删除所有</el-button>
                        <el-button type="primary" style="margin:0px 10px;" @click="confirmBtn">确认签署</el-button>
                        <el-button type="primary" style="margin:0px 10px;" @click="getPDFXY">获取pdf内坐标</el-button>

                    </div>

                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import pdf from 'vue-pdf';

    export default {
        name: 'signingArea',
        components: {
            pdf
        },
        data() {
            return {
                url: 'http://storage.xuetangx.com/public_assets/xuetangx/PDF/PlayerAPI_v1.0.6.pdf',

                currentPage: 1, // 默认第一页
                pageCount: null, // 总页数
                // 拖拽数据
                dropData: [],
                // 参数数据（可拖拽多个）
                dragList: [
                    {
                        name: 'DIV',
                        img: require('../../../assets/img/企业章.png'),
                        width: 50,
                        height: 50,
                        left: 0,
                        top: 0,
                        type: 1,
                        model: '111',
                        id: 1
                    },
                    {
                        name: '数字',
                        img: require('../../../assets/img/财务章.png'),
                        width: 50,
                        height: 50,
                        left: 0,
                        top: 0,
                        type: 2,
                        model: '',
                        id: 2
                    },
                    {
                        name: '日期',
                        img: require('../../../assets/img/合同章.png'),
                        width: 50,
                        height: 50,
                        left: 0,
                        top: 0,
                        type: 3,
                        model: '',
                        id: 3
                    }
                ],
                // 拖动的当前对象
                currentItem: {},
                curretnInput: '',
                currentName: '',
                // 位置xy
                x: '',
                y: '',
                positionX: '',
                positionY: '',
                offsetLeft: '',
                offsetTop: '',
                moveEvent: true
            };
        },
        computed: {},
        methods: {
            // 获取签章内部xy坐标
            getPDFXY() {
                console.log(this.offsetLeft, this.offsetTop);
            },
            // 内部移动事件
            move(e, item) {
                if (this.moveEvent == true) {
                    console.log(e);
                    let odiv = e.target;// 获取目标元素
                    //计算出鼠标相对点击元素的位置,e.clientX获取的是鼠标的位置，OffsetLeft是元素相对于外层元素的位置
                    let x = e.clientX - odiv.offsetLeft;
                    let y = e.clientY - odiv.offsetTop;
                    this.offsetLeft = odiv.offsetLeft;
                    this.offsetTop = odiv.offsetTop;
                    document.onmousemove = (e) => {
                        // 获取拖拽元素的位置
                        let left = e.clientX - x;
                        let top = e.clientY - y;
                        this.offsetLeft = left;
                        this.offsetTop = top;
                        // 把拖拽元素 放到 当前的位置
                        if (left <= 0) {
                            left = 0;
                        } else if (left >= document.documentElement.clientWidth - odiv.offsetWidth) {
                            //document.documentElement.clientWidth 屏幕的可视宽度
                            left = document.documentElement.clientWidth - odiv.offsetWidth;
                        }
                        // if (top >= document.getElementsByClassName('pdf-content').offsetWidth - 100) {
                        //     top = document.getElementsByClassName('pdf-content').offsetWidth - 100;
                        // }
                        if (left >= document.getElementById('exportPdf').offsetWidth - 150) {
                            left = document.getElementById('exportPdf').offsetWidth - 150;
                        }
                        if (top <= 0) {
                            top = 0;
                        } else if (top >= document.getElementById('exportPdf').clientHeight - odiv.offsetHeight) {
                            // document.documentElement.clientHeight 屏幕的可视高度
                            top = document.getElementById('exportPdf').clientHeight - 150;

                        }
                        odiv.style.left = left + 'px';
                        odiv.style.top = top + 'px';

                    };
                    // 为了防止 火狐浏览器 拖拽阴影问题
                    document.onmouseup = (e) => {
                        document.onmousemove = null;
                        document.onmouseup = null;
                    };
                } else {
                    event.stopPropagation();
                }

            },
            dragstart(e, item) {
                // 将拖拽对象的参数传递给拖拽存放地
                e.dataTransfer.setData('item', JSON.stringify(item));
            },
            dragend(e) {
                // 清除
                e.dataTransfer.clearData();
            },
            // 拖拽事件，获取参数
            drop(e) {
                console.log(e);
                if (this.moveEvent == true) {
                    // 获取拖拽对象的参数
                    let data = e.dataTransfer.getData('item');
                    data = JSON.parse(data);
                    // 鼠标落点位置相对于当前拖拽存放地的 x y
                    data.left = e.layerX;
                    data.top = e.layerY;
                    // 存放到当前拖拽对象生成的列表中
                    this.dropData.push(data);
                }

            },
            // 获取参数
            getModel(item) {
                console.log(this.offsetLeft, this.offsetTop, this.currentPage);
                this.dropData = this.dropData.map(item => {
                    item.selectName = '';
                    return item;
                });
                item.selectName = 'select';
                this.curretnInput = item.model;
                this.currentItem = item;
            },
            // 设置input输入
            setModel() {
                this.currentItem.model = this.curretnInput;
            },
            pageCountChange($event) { // pdf总页数
                this.pageCount = $event;
            },
            currentPageChange($event) {// pdf当前页数
                this.currentPage = $event;
            },
            addPage() { // 翻页+
                if (this.pageCount !== this.currentPage) {
                    this.currentPage += 1;
                }
            },
            backPage() { // 翻页-
                if (this.currentPage !== 1) {
                    this.currentPage -= 1;
                }
            },
            //删除
            deleteBtn(item, index) {
                console.log(item, index);
                this.dropData.splice(index, 1);
                this.moveEvent = true;
            },
            confirmBtn() {
                console.log(this.dropData);
                if (this.dropData.length != 0) {
                    this.moveEvent = false;
                } else {
                    this.$message.error('请选择印章进行签署');
                }
            }
        }

    };
</script>

<style lang="less" scoped>
    .bigBox {
        width: 100%;
        height: 100%;
        overflow: hidden;
    }

    .leftBox {
        width: 250px;
        display: block;
        position: absolute;
        left: 0;
        top: 65px;
        bottom: 0;
        overflow-y: scroll;
        background-color: #fff;
    }

    .middleBox {
        overflow: scroll;
        position: absolute;
        left: 250px;
        right: 0;
        top: 65px;
        bottom: 0;
        transition: left .3s ease-in-out;
        background: #ffffff;
    }

    .pdfBox {
        width: 100%;
        min-width: 1200px;
        height: 100%;
        display: flex;

    }

    .pdfLeftBox {
        background-color: #f0f0f0;
        width: 80%;
        height: 100%;
    }

    .pdf {
        padding: 30px;
    }

    .pdfRightBox {
        width: 20%;
        background-color: #fff;
    }

    .pdf-box {
        display: flex;
        justify-content: center;
        margin: 15px 0px;
    }

    .pdf-content {
        width: 950px;
        height: 100%;
    }

    .pdf-content {
        margin: auto;
        height: 100%;
    }

    .pageNumber {
        width: 50px;
        line-height: 30px;
        margin: 0px 20px;
    }

    .drag {
        overflow: hidden;
        overflow-y: scroll;
        width: 950px;
        height: 100%;
        position: relative;
        margin: auto;

        .box {
            position: absolute;
            top: 0px;
            left: 0px;
            width: 150px;
            height: 150px;
            user-select: none;
            cursor: pointer;
        }
    }

    .oneDiv {
        width: 150px;
        height: 150px;
        text-align: center;
        // margin: 50px;
        float: left;
        margin: 20px;
        border: 1px solid;
        line-height: 30px;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>
